import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Order matters: Nocturne defines the tokens, Kagami retunes them.
import "./styles/nocturne.css";
import "./styles/kagami.css";

import App from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
